export default function Loader(props) {
  return props.show ? (
    <div className="full_loader">
      <div className="image_container">
        <div className="loader_icon">
          <img
            src={process.env.PUBLIC_URL + "/image/loader.gif"}
            alt="Loading"
          />
        </div>
      </div>
    </div>
  ) : null;
}
